import React from "react";

import { useBreakpoint } from "../../../../../../../hooks";
import { Box, Center, Stack } from "../../../../../../layout";
import { Heading, Text } from "../../../../../../typography";
import { StandardContent } from "../../../../types";
import ModalButton from "./components/ModalButton";

type Props = {
  children: StandardContent;
  noTopImageContainer: boolean;
};

export default function StandardContentLayout({
  children,
  noTopImageContainer
}: Props) {
  const {
    topImage,
    title,
    subtitle,
    body,
    primaryButtonProps,
    secondaryButtonProps
  } = children;

  const { isMobileOnly } = useBreakpoint();

  return (
    <Box
      minHeight="100%"
      display="flex"
      flexDirection="column"
      gap="xxlarge"
      paddingX={["none", "xxlarge"]}
      paddingTop={["xxlarge", "none"]}
    >
      <Box
        flex="1 0"
        display="flex"
        flexDirection="column"
        gap="xxlarge"
        justifyContent="center"
      >
        {(topImage || title) && (
          <Box
            display="flex"
            flexDirection="column"
            gap="20"
            alignItems="center"
          >
            {topImage && (
              <Box width={noTopImageContainer ? "100%" : ["200px", "160px"]}>
                <Center>{topImage}</Center>
              </Box>
            )}
            {title && (
              <Box maxWidth="400px">
                <Heading level="3" align="center">
                  {title}
                </Heading>
              </Box>
            )}
          </Box>
        )}
        {subtitle && (
          <Text lineHeight="large" align="center">
            <Stack space="12">{subtitle}</Stack>
          </Text>
        )}
        {body}
      </Box>
      {(primaryButtonProps || secondaryButtonProps) && (
        <Box flex="0">
          {isMobileOnly ? (
            <Stack space="xlarge">
              {primaryButtonProps && (
                <ModalButton {...primaryButtonProps} cta="primary" />
              )}
              {secondaryButtonProps && (
                <ModalButton {...secondaryButtonProps} cta="secondary" />
              )}
            </Stack>
          ) : (
            <Box width="100%">
              {primaryButtonProps && secondaryButtonProps ? (
                <Box
                  display="flex"
                  gap="xlarge"
                  flexWrap="wrap-reverse"
                  whiteSpace="nowrap"
                >
                  <Box flex="1 0 208px">
                    <ModalButton {...secondaryButtonProps} cta="secondary" />
                  </Box>
                  <Box flex="1 0 208px">
                    <ModalButton {...primaryButtonProps} cta="primary" />
                  </Box>
                </Box>
              ) : (
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Box minWidth="208px">
                    {primaryButtonProps ? (
                      <ModalButton {...primaryButtonProps} cta="primary" />
                    ) : secondaryButtonProps ? (
                      <ModalButton {...secondaryButtonProps} cta="secondary" />
                    ) : null}
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
